import { Injectable, signal } from '@angular/core';
import type { MapMarker } from '@luzula/luzula-lib';

/**
 * Teilt die zuletzt in der Kartenansicht (alle-bohrpunkte) berechneten Projekt-
 * Marker (Punkte) mit anderen Ansichten — insbesondere dem Druck-Layout-Snapshot.
 *
 * Zweck: Der Snapshot soll die echte Kartenansicht spiegeln (inkl. Punkte), ohne
 * die aufwändige Lade-/Migrations-/Filter-/Marker-Konvertierungslogik aus
 * {@link AlleBohrpunkteComponent} zu duplizieren. Die Kartenansicht „published"
 * ihre fertigen Marker hierher; der Snapshot konsumiert sie.
 */
@Injectable({ providedIn: 'root' })
export class ProjectMarkersService {
	readonly markers = signal<MapMarker[]>([]);
	readonly pointsFilter = signal<boolean[]>([]);

	publish(markers: MapMarker[], pointsFilter: boolean[]): void {
		this.markers.set(markers ?? []);
		this.pointsFilter.set(pointsFilter ?? []);
	}
}
